/**
 * Format price to display in Euro currency
 * Converts $ to € and handles various price formats
 */
export const formatPrice = (price) => {
  if (!price) return '';
  
  // Convert string to handle it
  let formattedPrice = String(price);
  
  // Replace $ with €
  formattedPrice = formattedPrice.replace(/\$/g, '€');
  
  // If price doesn't have a currency symbol and is just a number, add €
  // But only if it looks like a numeric price (contains digits)
  if (/^\d+/.test(formattedPrice.trim()) && !/[€$]/.test(formattedPrice)) {
    formattedPrice = '€' + formattedPrice.trim();
  }
  
  return formattedPrice;
};
